var map = {
	"./ar.json": [
		47081,
		7081
	],
	"./bn.json": [
		13635,
		3635
	],
	"./de.json": [
		56809,
		6809
	],
	"./en.json": [
		9012
	],
	"./es.json": [
		66643,
		6643
	],
	"./fr.json": [
		97113,
		7113
	],
	"./gu.json": [
		20506,
		506
	],
	"./hi.json": [
		17769,
		7769
	],
	"./it.json": [
		98471,
		8471
	],
	"./ja.json": [
		1529,
		1529
	],
	"./kn.json": [
		52231,
		2231
	],
	"./ko.json": [
		21436,
		1436
	],
	"./ml.json": [
		28320,
		8320
	],
	"./mr.json": [
		97553,
		7553
	],
	"./pa.json": [
		97942,
		7942
	],
	"./ru.json": [
		89871,
		9871
	],
	"./ta.json": [
		17256,
		7256
	],
	"./te.json": [
		81805,
		1805
	],
	"./ur.json": [
		77065,
		7065
	],
	"./zh.json": [
		41861,
		1861
	]
};
function webpackAsyncContext(req) {
	if(!__webpack_require__.o(map, req)) {
		return Promise.resolve().then(function() {
			var e = new Error("Cannot find module '" + req + "'");
			e.code = 'MODULE_NOT_FOUND';
			throw e;
		});
	}

	var ids = map[req], id = ids[0];
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__.t(id, 3 | 16);
	});
}
webpackAsyncContext.keys = function() { return Object.keys(map); };
webpackAsyncContext.id = 36617;
module.exports = webpackAsyncContext;